const setShareInfo = (val) => {
  let firstPath = location.pathname.split('/')[1]
  const shareIcon = ['gb', 'zr'].indexOf(firstPath)>=0?firstPath:'kan'
  let newJson = {
    title: val.shareTitle,
    desc: val.shareDesc,
    imgUrl: new RegExp('topic').test(location.href)?`https://s6.bihukankan.com/h5static/img/0515topic-header-small.png`:`https://s6.bihukankan.com/h5static/img/${shareIcon}-share.png`,
  }
  wx.onMenuShareTimeline(newJson);
  wx.onMenuShareAppMessage(newJson);
}
export default setShareInfo